import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "nav-item" }
const _hoisted_2 = {
  key: 0,
  class: "ai-tag"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-count"
}
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.item.to)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: _ctx.item.to,
          title: _ctx.item.label,
          class: _normalizeClass(_ctx.item.class)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              icon: _ctx.item.icon
            }, null, 8, ["icon"]),
            _createElementVNode("span", {
              style: _normalizeStyle(_ctx.item.count ? 'flex:1' : '')
            }, [
              _createTextVNode(_toDisplayString(_ctx.item.label), 1),
              (_ctx.item.aiTag)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, "AI"))
                : _createCommentVNode("", true)
            ], 4),
            (_ctx.item.count)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.item.count), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to", "title", "class"]))
      : (_ctx.item.href)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: _ctx.item.href,
            target: "_blank",
            title: _ctx.item.label,
            class: _normalizeClass(_ctx.item.class)
          }, [
            _createVNode(_component_svg_icon, {
              icon: _ctx.item.icon
            }, null, 8, ["icon"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.item.label), 1)
          ], 10, _hoisted_4))
        : (_openBlock(), _createElementBlock("a", {
            key: 2,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.item.action()), ["prevent"])),
            title: _ctx.item.label,
            class: _normalizeClass(_ctx.item.class)
          }, [
            _createVNode(_component_svg_icon, {
              icon: _ctx.item.icon
            }, null, 8, ["icon"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.item.label), 1)
          ], 10, _hoisted_5)),
    (_ctx.showStar)
      ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          type: "button",
          class: _normalizeClass(_ctx.favorite ? 'nav-fav on' : 'nav-fav'),
          title: _ctx.favorite ? 'Remove from favorites' : 'Add to favorites',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-favorite', _ctx.item.key)))
        }, [
          _createVNode(_component_svg_icon, {
            icon: _ctx.favorite ? 'starfilled' : 'star'
          }, null, 8, ["icon"])
        ], 10, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}